// src/services/profiles/guestProfileApi.ts

import baseApi from "../../lib/baseApi";
import { UpdateGuestProfileResponse } from "../../types/profiles/updateGuestProfileResponse";

// Guest Profile APIs ---------------------------------------------------------------
export const fetchGuestProfileApi = async () => {
  const response = await baseApi.get("/profiles/guestusers/my-profile/");
  return response.data;
};

export const updateGuestProfileApi = async (
  updatedData: any
): Promise<UpdateGuestProfileResponse> => {
  const response = await baseApi.post(
    "/profiles/guestusers/update-profile/",
    updatedData
  );

  return {
    message: response.data.message,
    guest: response.data.guest,
    user: response.data.user,
  };
};

export const updateGuestProfileImageApi = async (formData: FormData) => {
  const response = await baseApi.post(
    "/profiles/guestusers/update-profile-image/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};